module.exports = __webpack_public_path__ + "img/not_found_image.6ce9535f.jpg";